import _ from 'lodash/fp';
import { handleActions } from 'redux-actions';

export default handleActions({
  // add new dataSources to the end of the existing ones
  LOAD_DATA_SOURCES: (state, { payload }) => _.assignWith(
    (DS, newDS) => newDS ? (DS || []).concat(newDS) : DS,
    state,
    payload
  ),

  UPDATE_LOCATION: (state, { payload }) => {
    if (!payload) return {};

    if (payload.action === 'POP') {
      return state.previousDataSources;
    }

    return { previousDataSources: state };
  },
}, {});



// WEBPACK FOOTER //
// ./src/reducer/dataSources.js